<template>
  <div
    :class="{
      'cell-edit': editable,
      'not-valid': error,
    }"
    class="cell"
  >
    <InfoTooltip
      v-if="error"
      small
      :right="errorPosition === 'right'"
      :left="errorPosition === 'left'"
    >
      <template #element>
        <div class="cell-tooltip">
          <slot />
        </div>
      </template>
      <div class="cell-error-container">
        <div class="error-icon">
          <ErrorIcon />
        </div>
        <div>{{ error }}</div>
      </div>
    </InfoTooltip>
    <slot v-else />
  </div>
</template>

<script>
  import ErrorIcon from '@/assets/icons/error.svg';
  import InfoTooltip from '@/components/ui/InfoTooltip';

  export default {
    name: 'Cell',
    components: { ErrorIcon, InfoTooltip },
    props: {
      editable: {
        type: Boolean,
        default: false,
      },

      error: {
        type: String,
        default: '',
      },

      errorPosition: {
        type: String,
        default: 'right', // left|right
      },
    },
  };
</script>
<style scoped lang="scss">
  @import 'src/styles/colors';

  .cell {
    position: relative;
    padding: 6px 12px;
    box-shadow: inset 1px 1px 0 #e8ebf0, 1px 1px 0 #e8ebf0;
    background-color: #fff;
    -webkit-transition: background-color 200ms ease;
    transition: background-color 200ms ease;
    cursor: default;
    font-weight: 500;
    font-size: 14px;
    color: $text-primary;

    [contenteditable] {
      outline: 0 solid transparent;
    }

    &.not-valid {
      background-color: $surface-error !important;
    }

    &.cell-edit[contenteditable='true']:focus {
      box-shadow: 0 0 0 2px #3581f3;
      border-radius: 2px;
      z-index: 2071;
    }

    &:hover {
      background-color: $surface1-selected;
    }
  }

  .cell .cell-error-container {
    display: flex;
    padding: 8px 12px;
  }

  .cell-tooltip {
    width: 100%;
    display: flex;
    align-items: center;
  }
</style>
